import React from "react";

function Clientele() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Our Clientele</b></h2>
           <div style={{color:"#5E5550"}}>
           <p>
            The firm is retained by many Bahraini entities & institutions, international and local banks, investment advisers, international accountancy firms, multinational companies and high net worth individuals from Bahrain and from all around the world. The profile of the firm’s clients and practice has resulted in excellent contacts and working relationships with the Bahraini entities and leading international law firms.
            </p>
          <h2 style={{color:"#3A3A3A"}}><b>Experience in Major Projects</b></h2>
          <p>
          The firm, has extensive experience in providing local Bahraini advice with respect to major projects.  The Firm’s technical legal skills together with its enviable business connections ensures that its clients’ are fully advised and that their interests are protected at all times.  
The Firm has been involved with matters that include but are not limited to major real estate projects, large scale industrial companies, educational institutions, Hotels in Bahrain,  acquisitions in and out of the Kingdom of Bahrain, acquisitions of several industrial companies and a financial institution in Bahrain, acquisitions of various restaurants franchises and fast food outlets in Bahrain. 

          </p>
           </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default Clientele;
